export const FETCH_STREAMS = "FETCH_STREAMS";
export const FETCH_STREAM = "FETCH_STREAM";


// New types for Featured NFT
export const SET_FEATURED_NFT = "SET_FEATURED_NFT";
export const CLEAR_FEATURED_NFT = "CLEAR_FEATURED_NFT";

export const UPDATE_OTHER_PROPERTY = 'UPDATE_OTHER_PROPERTY';
